export class TaxForm {
    public FileName: string;
    public FileBytesBase64: string;
    public AttachmentFilePath: string;
    public GPVID: string;
  }



// WEBPACK FOOTER //
// ./src/app/models/TaxForm.ts